import request from "@/utils/request";

export default {
    getItems: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/answers', params })
            .then(res => {
                if (res.data) {
                    commit('PROCESS_RES', res.data);
                }
            }).catch(error => {
                if (error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    create: async({ dispatch }, data) => {
        return request({
            method: 'post',
            url: `/forms/${data.formId}/answer`,
            data: {
                ...Object.reject(data, ['formId'])
            }
        }).then(res => {
            if (res.data) {
                dispatch('getItems', {
                    page: 1
                });

                return res.data.id;
            }
        }).catch(err => {
            const message = err.response && err.response.data && err.response.data.message;

            if (message) {
                dispatch('alert/addMessage', {
                    type: 'error',
                    message
                }, { root: true });
            }
        });
    },

    save: async({ commit, dispatch }, data) => {
        await request({
            method: 'put',
            url: `/answers/${data.id}`,
            data
        }).then(res => {
            if (res.data) {
                const { phoneNumber } = data;

                commit('SAVE_FORM_COMPONENT_ANSWER', {
                    ...res.data,
                    phoneNumber
                });

                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });
            }
        }).catch(err => {
            const message = err.response && err.response.data && err.response.data.message;

            if (message) {
                dispatch('alert/addMessage', {
                    type: 'error',
                    message
                }, { root: true });
            }
        });
    }
};
